import IntakeOutputChartScreen from "../../components/ipd/intakeOutput/IntakeOutputChartScreen";

function IntakeOutputChart() {
  return <IntakeOutputChartScreen />;
}

export default IntakeOutputChart;
